import { api } from './client.js';

// 로그인 실패(401)는 「세션이 끊김」이 아니므로 전역 처리로 넘기지 않습니다.
export function signup({ email, password }) {
    return api('/auth/signup', { method: 'POST', body: { email, password }, skipAuthHandler: true });
}

export function login({ email, password }) {
    return api('/auth/login', { method: 'POST', body: { email, password }, skipAuthHandler: true });
}

export function logout() {
    return api('/auth/logout', { method: 'POST', skipAuthHandler: true });
}

export function fetchMe({ signal } = {}) {
    return api('/auth/me', { signal, skipAuthHandler: true });
}

/** 키가 들어 있는 소셜 로그인 제공자(D108). 키가 없는 방법은 버튼을 그리지 않습니다 */
export function fetchProviders({ signal } = {}) {
    return api('/auth/providers', { signal, skipAuthHandler: true });
}

/** 소셜 로그인에서 돌아온 일회용 표를 세션 토큰으로 바꿉니다 → { token, user, isNew } */
export function redeemTicket(ticket) {
    return api('/auth/ticket', { method: 'POST', body: { ticket }, skipAuthHandler: true });
}
